<template>
    <div class="normal-container">
        <ShopwareBreadcrumbs :breadcrumbPrefixEnabled="false" />
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps({
        pageTitle: String,
    });
</script>
